import ScrollToTop from '../Components/ScrollToTop';
import HeroSection9 from '../Components/HeroSection9/index9';
import Infosection8 from '../Components/Infosection8/Index8';
import { homeObjOne8 } from '../Components/Infosection8/Data8';
import Card_service from '../Components/Card_service/Card';
import Footer from '../Components/Footer/Footer';

const Service = () => {
  return (
    <>
      <ScrollToTop />
      <HeroSection9 />
      <Infosection8 {...homeObjOne8} />
      <Card_service />
      <Footer />
    </>
  )
}

export default Service